export { PLUGIN_KEY, PLUGIN_PRIORITY, TouchScroll } from "./touchScroll.mjs";


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/touchScroll/index.mjs
// module id = 1550
// module chunks = 1